module.exports = __webpack_public_path__ + "static/media/19.804e0859.jpg";